import React, { useState } from "react";
import { useAlert } from "react-alert";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import {
  AccordionBody,
  Answer,
  FormContainer,
  FormTitle,
  InputField,
  Question,
  SumbitButton,
  Title,
} from "./faq.components";
import { Box, AccordionSummary, AccordionDetails, Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import faqContent from "./content";
import { saveUserQuery } from "../../services/query";
import QueryConfirmationDialog from "../dialog/queryConfirmationDialog";

function FAQ() {
  const alert = useAlert();
  const [expanded, setExpanded] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);

  const handleSubmit = async () => {
    if (validate()) {
      const queryData = {
        name: name,
        phone: phone,
        emailID: email,
        message: message,
      };
      await saveUserQuery(queryData)
        .then((response) => {
          if (response.status === 200) {
            setOpen(true);
            setName("");
            setPhone("");
            setEmail("");
            setMessage("");
          }
        })
        .catch((error) => console.log(error));
    }
  };

  return (
    <OuterWrapper
      sx={{
        pt: { xs: "70px", sm: "150px" },
        pb: "70px",
        bgcolor: "#F8FBFE",
      }}
    >
      <InnerWrapper>
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "center", md: "flex-start" }}
        >
          <DisplayQuestions />
          {QueryForm()}
        </Stack>
      </InnerWrapper>
    </OuterWrapper>
  );

  function DisplayQuestions() {
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };

    return (
      <Box px={1.25} sx={{ width: { md: 690 } }}>
        <QueryConfirmationDialog open={open} setOpen={setOpen} />
        <Title>Frequently Asked Questions</Title>
        <Box>
          {faqContent.map((data, index) => {
            return (
              <AccordionBody
                expanded={expanded === `panel${index}`}
                onChange={handleChange(`panel${index}`)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ height: 75 }}
                >
                  <Question>{data.question}</Question>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 0 }}>
                  <Answer>{data.answer}</Answer>
                </AccordionDetails>
              </AccordionBody>
            );
          })}
        </Box>
      </Box>
    );
  }

  function QueryForm() {
    return (
      <FormContainer
        direction="column"
        justifyContent="center"
        alignItems="center"
        spacing={2.5}
        sx={{ width: { xs: "95%", md: 500 }, mt: { xs: 7, md: 1 } }}
      >
        <FormTitle>
          Have a more specific query, <br /> Reach out to us now.
        </FormTitle>
        <InputField
          component="input"
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <InputField
          component="input"
          type="text"
          placeholder="Phone No"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <InputField
          component="input"
          type="email"
          placeholder="Email id"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <InputField
          txtArea="100px"
          component="textarea"
          placeholder="Type your message here"
          value={message}
          sx={{ py: 3 }}
          onChange={(e) => setMessage(e.target.value)}
        />
        <SumbitButton onClick={handleSubmit}>send</SumbitButton>
      </FormContainer>
    );
  }

  function validate() {
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

    if (!name) {
      alert.error("please enter the name");
      return false;
    }
    if (!phone || !phoneRegex.test(phone)) {
      alert.error("please enter a valid phone number");
      return false;
    }
    if (!email || !emailRegex.test(email)) {
      alert.error("please enter a valid email id");
      return false;
    }
    if (!message) {
      alert.error("please enter the message");
      return false;
    }
    return true;
  }
}

export default FAQ;
